import React from 'react';
import SectionMessage, { SectionMessageAction } from '@atlaskit/section-message';
import { Stack, Text } from '@atlaskit/primitives/compiled';
import type { HealthcheckSuggestedActionLink } from '../../common/types.tsx';

const HealthcheckSuggestedAction = (props: {
	error: string;
	action: string | null;
	link: HealthcheckSuggestedActionLink | null;
}) => {
	const actions = props.link
		? [
				<SectionMessageAction key="action" href={props.link.link}>
					{props.link.name}
				</SectionMessageAction>,
			]
		: [];

	return (
		<>
			<SectionMessage title="Step Failed" appearance="error" actions={actions}>
				<Stack space="space.100">
					<Text>{props.error}</Text>
					<Text>{props.action}</Text>
				</Stack>
			</SectionMessage>
		</>
	);
};

export default HealthcheckSuggestedAction;
